import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
  selector: 'saLoader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
  public counter = 0; // To display the counter
  public show = false;

  private saLoaderSubscription: Subscription | undefined;
  private counterSubscription: Subscription | undefined;

  constructor(private loader: LoaderService) {}

  ngOnInit() {
    // Subscribe to loader state
    this.saLoaderSubscription = this.loader.saLoaderState.subscribe((state) => {
      this.show = state.show;
    });

    // Subscribe to counter updates
    this.counterSubscription = this.loader.counterState.subscribe((count) => {
      this.counter = count;
    });
  }

  ngOnDestroy(): void {
    if (this.saLoaderSubscription) {
      this.saLoaderSubscription.unsubscribe();
    }
    if (this.counterSubscription) {
      this.counterSubscription.unsubscribe();
    }
  }
}

